import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { IoMdHeartEmpty, IoMdHeart } from "react-icons/io";
import { useCartWishlist } from '../../pages/CartWishlistContext';

const ProductCard = (props) => {
  const { isLogin, setIsLogin, isCart, setIsCart } = useCartWishlist();

  useEffect(() => {
    if (localStorage.getItem('userToken')) {
      setIsLogin(true);
    } else {
      setIsLogin(false);
    }
  }, []);
  return (
    <>
      <div className='pcard'>
        <div className="productImg">
          <Link to={`/product/${props.ProductSlug}`}>
            {props.Quantitys === 0 ? <div className='outofstock'>Out of Stock</div> : null}
            <img src={props.ImgUrl} alt='Logo' title='Logo' />
            {props.Offer ?
              <div className="offers">
                <p>{`${props.Offer}% Off`}</p>
              </div>
              : null
            }
            {props.ProductLabel != '' &&
              <div className='priseLabel'>
                <p>{props.ProductLabel}</p>
              </div>
            }
          </Link>
        </div>
        <div className="procard-content">
          {props.PlanName != '' && (<h4 className={`planstitle ${props.PlanName}`}>{props.PlanName}</h4>)}
          <Link to={`/product/${props.ProductSlug}`}><div className="pname">{props.Name}</div></Link>

          {props.Model?.trim() && (
            <div className="brandmodal">
              <p>{props.Model}</p>
            </div>
          )}

          <div className="procard-navs">
            <div>
              <span className="pprice">&#8377;{props.Price}</span>
              <span className="pold">&#8377;{props.OldPrice}</span>
            </div>
          </div>

          {props.PlanContent != '' && (<p className='planContents'>{props.PlanContent}</p>)}
          <div className="productcard-btns">
            <ul className={isLogin ? 'withio' : ''}>
              {props.Cart.some(item => item.sku_id == props.SkuID) ?
                <li>
                  {props.ProductLabel != '' ?
                    <>
                      {props.ProductLabel == 'Select Your Phone Model' ?
                        <Link to={`/product/${props.ProductSlug}`} className="btn btn-border" >View Details</Link>
                        :
                        <button className="btn btn-border" onClick={() => setIsCart(!isCart)}>View Cart</button>
                      }
                    </>
                    :
                    <button className="btn btn-border" onClick={() => setIsCart(!isCart)}>View Cart</button>
                  }
                </li> : (
                  <>
                    {props.Quantitys === 0 ?
                      <li>
                        <Link to={`/product/${props.ProductSlug}`} className="btn btn-border">View Details</Link>
                      </li>
                      :
                      <li>
                        {props.ProductLabel != '' ?
                          <>
                            {props.ProductLabel == 'Select Your Phone Model' ?
                              <Link to={`/product/${props.ProductSlug}`} className="btn btn-border">View Details</Link>
                              :
                              <button className="btn btn-border" onClick={() => props.addToCart(props.SkuID)}>+ Add To Cart</button>
                            }
                          </>
                          :
                          <button className="btn btn-border" onClick={() => props.addToCart(props.SkuID)}>+ Add To Cart</button>
                        }

                      </li>
                    }
                  </>
                )}

              {isLogin ? <li>
                <button className="btn-add" onClick={() => props.ToggleWishlist(props.SkuID)}>
                  {props?.Wishlist.has(props.SkuID) ? <IoMdHeart /> : <IoMdHeartEmpty />}
                </button>
              </li> : null}
            </ul>
          </div>
        </div>
      </div >
    </>
  );
}

export default ProductCard;